import React from 'react';
import { Link } from 'react-router-dom';

function SummaryBlog() {
  return (
    <section>
      <h2 className="mt-3">
        <Link className="gradient-color" to="/blog">
          Blog
        </Link>
      </h2>
      <Link to="/gwas-harmonization-ukbiobank-disgenet" className="summary-list text-wrap">
        Harmonizing UK Biobank GWAS Data with DISGENET: Mapping Phecodes to UMLS CUIs
      </Link>
      <Link to="/DISGENET-Version-25-1-Whats-New" className="summary-list text-wrap">
        DISGENET Version 25.1: What’s New?
      </Link>
      <Link to="/DISGENET-Version-24-4-Whats-New" className="summary-list text-wrap">
        DISGENET Version 24.4: What’s New?
      </Link>
      <Link to="/DISGENET-Version-24-3-Whats-New" className="summary-list text-wrap">
        DISGENET Version 24.3: What’s New?
      </Link>
      <Link to="/The-Key-To-Clinical-Trial-Success" className="summary-list text-wrap">
        Genetics In Drug Discovery: The Key To Clinical Trial Success?
      </Link>
      <Link to="/disgenet-academic-license-guide" className="summary-list text-wrap">
        DISGENET Academic License: Eligibility, Application & Free Access
      </Link>
      <Link to="/disgenet-nlp-to-accelerate-drug-development" className="summary-list text-wrap">
        DISGENET NLP to Accelerate Drug Development
      </Link>
      <Link to="/The-Next-Chapter-For-Disease-Genomics-Research" className="summary-list text-wrap">
        DISGENET: The Next Chapter For Disease Genomics Research
      </Link>
    </section>
  );
}

export default SummaryBlog;
